"use strict";

import $ from "jquery";

const handleCheckboxDropdownClick = function (e) {
  if ($(e.target).closest(".checkbox-tree-container").length) {
    return;
  }
  const $dropdown = $(e.target).closest(".checkbox-dropdown"),
    $ul = $dropdown.children("ul");

  if ($ul.hasClass("collapsed")) {
    $ul.removeClass("collapsed");

    $ul.show();
  } else {
    $ul.addClass("collapsed");

    $ul.hide();
  }
};

const closeCheckboxDropdown = function (e) {
  if ($(e.target).closest(".checkbox-dropdown").length) return;

  const $dropdown = $(".data_hub_search_form .checkbox-dropdown");
  const $ul = $dropdown.children("ul");

  if (!$ul.hasClass("collapsed")) {
    $dropdown.stop();
    $ul.addClass("collapsed");

    $ul.hide();
  }
};

const setSelections = e => {
  const $dropdown = $(e.target).closest(".checkbox-dropdown");
  const $ul = $dropdown.children("ul");

  const placeholderText = $dropdown.find(".placeholder .selection").text() || "Please select countries...";
  // Set div text
  const selections = $ul.find("input:checked").map(function (i, input) {
    return $(input).val();
  }).toArray()
  .filter(selection => selection.length);
  const $selectionSpan = $(e.target).closest(".checkbox-dropdown").children(".selection");

  if (selections.length) {
    if (selections.length > 3) {
      $selectionSpan.text(selections.length + " selected");
    } else {
      $selectionSpan.text(selections.join(", "));
    }
  } else {
    $selectionSpan.text(placeholderText);
  }
};

const checkUlState = function ($ul) {
  // Set/clear indeterminate check for all regions
  $ul.children("li").map(function () {
    const $li = $(this);
    const $childUl = $li.children("ul").first();

    const $children = $childUl.children("li.checkbox-tree-child").children("label");
    const $selectedChildren = $children.find("input:checked");
    const indeterminateChildren = $children.find("input").filter((i, e) => e.indeterminate).length;
    const $allChildren =  $children.find("input");
    const indeterminate = ($selectedChildren.length && ($selectedChildren.length !== $allChildren.length)) || indeterminateChildren > 0;

    checkUlState($childUl);

    $li.children("label").children("input")[0].indeterminate = indeterminate;
  });
};

const handleCheckboxDropdownSelection = function (e) {
  const $dropdown = $(e.target).closest(".checkbox-dropdown");
  const $topLevelUl = $dropdown.children("ul");

  checkUlState($topLevelUl);

  setSelections(e);
};

const checkboxTreeInit = function () {
  function selectAllChildren(parentCheckbox, checked) {
    const $parentCheckbox = $(parentCheckbox);

    if (checked) {
      const checkedChildren = $(parentCheckbox).closest("li").find("ul.checkbox-tree-container > li > label > input:checked").length;
      const anyChildrenChecked = checkedChildren > 0;
      if (anyChildrenChecked) {
        const $visibleBoxes = $parentCheckbox.closest("li").find("ul.checkbox-tree-container:visible").find("> li > label > input");
        $visibleBoxes.prop("indeterminate", false);
        $visibleBoxes.prop("checked", true);
      }
      parentCheckbox.indeterminate = false;
    } else {
      $parentCheckbox.closest("li").find("ul.checkbox-tree-container input").prop("checked", false);
    }
  }

  const checkParent = function (child) {
    const rootChild = $(child).closest("li.checkbox-tree-child").length === 0;

    if (rootChild) {
      return;
    }

    const $parent = $(child).closest("ul.checkbox-tree-container").closest("li").first();
    const $parentBox = $parent.find("input").first();

    const childrenContainer = $parent.children("ul.checkbox-tree-container");
    const children = childrenContainer.children("li.checkbox-tree-child");
    const total = children.length;
    const totalCheckedDescendents = children.find("input:checked").length;

    const checkedChildren = children.children("label").find("input:checked").length;

    if (total !== checkedChildren) {
      if ($parentBox.prop("type") !== "radio") {
        $parentBox.prop("checked", false);
        if (checkedChildren > 0) {
          $parentBox[0].indeterminate = true;
        }
      }
    } else {
      $parentBox.prop("checked", true);
      if ($parentBox.length > 0) {
        $parentBox[0].indeterminate = false;
      }
    }
    if (totalCheckedDescendents === 0) {
      if ($parentBox.prop("type") !== "radio") {
        childrenContainer.hide("fast");
      }
      if ($parentBox.length > 0) {
        $parentBox[0].indeterminate = false;
      }
    }

    checkParent($parentBox);
  };

  $("li > label > input").on("change", function() {
    const input = $(this);
    const that = this;
    const container = $("#left-sidebar")[0];
    let closestUl;

    if (this.checked) {
      input.closest("li").children("ul.checkbox-tree-container").show("fast");
      if (input.prop("type") === "radio") {
        $("[name='" + input.prop("name") + "']").not(this).trigger("change");
        if (that.offsetTop < window.pageYOffset) {
          that.scrollIntoView();
          container.scrollTop -= 20;
        }
      }
      selectAllChildren(this, true);
    } else {
      input.closest("li").find("ul.checkbox-tree-container li.checkbox-tree-child input").prop("checked", false);
      closestUl = input.closest("li").find("ul.checkbox-tree-container");
      closestUl.hide("fast");
      closestUl.find(".select2").val(null).trigger("change");
      selectAllChildren(this, false);
    }
  });

  $("li.checkbox-tree-child input").on("change", function() {
    checkParent(this);
  });

  $("input.checkbox-tree-toggle-all").on("change", function () {
    const ul = $(this).closest("ul");
    const checked = this.checked;

    const childUls = ul.find("ul");
    childUls.find("input").prop("checked", false);
    childUls.hide("fast");
    const scope = ul.children("li").children("label").children("input").not(this);
    scope.prop("checked", checked);
  });
};

const setInitialCheckedValues = () => {
  const fakeEventObj = {
    target: $(".checkbox-dropdown")[0]
  };

  setSelections(fakeEventObj);
};


$(document).on("turbolinks:load", function () {
  if (!$(".checkbox-dropdown").length) return;

  setInitialCheckedValues();
  $(".checkbox-dropdown").on("click", handleCheckboxDropdownClick);
  $(".checkbox-dropdown input").on("change", handleCheckboxDropdownSelection);
  $("body *").not(".checkbox-dropdown, .checkbox-dropdown *").on("click", closeCheckboxDropdown);
  checkboxTreeInit();

  $(window).on("resetForm", function () {
    setInitialCheckedValues();
  });
});
